<template>
    <div class="TQ_center">

        <!-- text area -->
        <div v-for="langCode in pb_questExplore_c.qex_langArr_ae"
             :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
             class="TQ_inline TQ_margin_8px TQ_width_100p TQ_maxWidth_350px TQ_padding_4px">

            <div class="TQ_text_24px TQ_padding_8px"> {{format_langCode(langCode)}} </div>

            <div v-for="introTabs in co_introTabs_ao">
                <div class="TQ_text_bold TQ_bg_purple_dark TQ_padding_8px">
                    {{introTabs.title_s[langCode]}}
                </div>

                <tq-textarea
                    :pb_uid_s="pb_uid_s"
                    pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px"
                    :pb_init-text_s="introTabs.initValue_blc_s[langCode]"
                    :pb_max-length_n="introTabs.maxLength_n"
                    :pb_placeholder_s="ass_strings.oneWord_text[langCode]"
                    :pb_rows_n="10"
                    :pe_change-text_s="(text_s) => {introTabs.initValue_blc_s[langCode] = text_s}"
                />


            </div>
        </div>

    </div>
</template>

<script>
    import {FB_QuestExplore} from "../../../../../functions/src/shareCode/Share_S_Classes";
  import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
  import WysiwygEditor from "../../../../components/complex/TqWysiwygEditor";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
  import TqCard from "../../../../components/basic/TqCard";
  import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
  import {helper_getDirectionByLangCode_fe} from "../../../../scripts/S_Helper";
    import {
        validator_enum_array_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqTextarea from "../../../../components/basic/TqTextarea";
    import TqTabs from "../../../../components/basic/TqTabs";
    import {
        validator_enum_fb,
        validator_objClass_fb,
        validator_objTypeof_fb
    } from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {FB_Wysiwyg} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {enum_typeof} from "../../../../../functions/src/shareCode/Share_S_Enum";

  export default {

      name: "C_Creator_EditQuests_Item_Explore_Info",
      components:{
          TqTabs,
          TqTextarea,
          TqCard,
          WysiwygEditor,
      },
      props:{

          ps_langCode_e :{
              type: String,
              require: true,
              validator(val){
                  return validator_enum_fb(enum_langCodes, val)
              }

          },
          pb_uid_s:{
              type:String,
              require: true
          },
          pb_questExplore_c :{
              type: FB_QuestExplore,
              require: true,
          },


      },
      data(){
          return{
              selectedTabIndex_vn : {val : 0},

              // imports
              ass_strings : ass_strings,
              format_langCode : format_langCode_fs,
              helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe
          }
      },
      computed: {
          co_introTabs_ao(){
              return [
                  {
                      title_s           : ass_strings.oneWord_description,
                      maxLength_n       : 1000,
                      initValue_blc_s   : this.pb_questExplore_c.qex_description_cla_s,
                  },
                  {
                      title_s           : ass_strings.fourWords_whatYouWillGet,
                      maxLength_n       : 1000,
                      initValue_blc_s   : this.pb_questExplore_c.qex_whatYouWillGet_cla_s,
                  },
                  {
                      title_s           : ass_strings.threeWords_whatToBring,
                      maxLength_n       : 1000,
                      initValue_blc_s   : this.pb_questExplore_c.qex_whatToBring_cla_s,
                  },
                  {
                      title_s           : ass_strings.sentence_whatElseYouShouldKnow,
                      maxLength_n       : 1000,
                      initValue_blc_s   : this.pb_questExplore_c.qex_whatElse_cla_s,
                  },
              ]
          }
      }


  }
</script>

<style scoped lang="scss">


</style>
